// filters
// stay, experience, eat, shop

const filterButtons = document.querySelectorAll('button.filter-option');
const destinationContainer = document.querySelector('.stg-column.destination-container');
const clearButton = document.querySelector('.filter-clear');
const mapMainContainer = document.querySelector('.map-main');
const mapWrapper = document.querySelector('.map-wrapper');
const mapDetails = document.querySelector('.map-details');
const gridWrapper = document.querySelector('.grid-wrapper');
const mapPin = document.querySelectorAll('.map-pin');
const mapDestination = document.querySelectorAll('.map-destination');
const destinationCards = document.querySelectorAll('.destination-wrapper');

let scrollLeftSpace = 100;
let scrollTopSpace = 45;

filterButtons.forEach((button) => {
    button.addEventListener('click', function () {
        button.classList.toggle('active');

        if (button.id === 'stay-filter') {
            destinationContainer.classList.contains('stay') ? (destinationContainer.classList.remove('stay'), mapDetails.classList.remove('stay')) : (destinationContainer.classList.add('stay'), mapDetails.classList.add('stay'));
        } else if (button.id === 'eat-filter') {
            destinationContainer.classList.contains('eat') ? (destinationContainer.classList.remove('eat'), mapDetails.classList.remove('eat')) : (destinationContainer.classList.add('eat'), mapDetails.classList.add('eat'));
        } else if (button.id === 'shop-filter') {
            destinationContainer.classList.contains('shop') ? (destinationContainer.classList.remove('shop'), mapDetails.classList.remove('shop')) : (destinationContainer.classList.add('shop'), mapDetails.classList.add('shop'));
        } else if (button.id === 'experience-filter') {
            destinationContainer.classList.contains('experience') ? (destinationContainer.classList.remove('experience'), mapDetails.classList.remove('experience')) : (destinationContainer.classList.add('experience'), mapDetails.classList.add('experience'));
        }
    })

});

clearButton.addEventListener('click', function () {
    destinationContainer.classList.remove('stay');
    destinationContainer.classList.remove('eat');
    destinationContainer.classList.remove('shop');
    destinationContainer.classList.remove('experience');

    
    mapDetails.classList.remove('stay');
    mapDetails.classList.remove('eat');
    mapDetails.classList.remove('shop');
    mapDetails.classList.remove('experience');

    filterButtons.forEach((button) => {
        button.classList.remove('active');
    })
});


// summer map events

let isDragging = false;
let startX, startY, scrollLeft, scrollTop;

document.querySelector('.map-main').addEventListener('mousedown', (e) => {
    isDragging = true;
    startX = e.pageX - document.querySelector('.map-main').offsetLeft;
    startY = e.pageY - document.querySelector('.map-main').offsetTop;
    scrollLeft = document.querySelector('.map-main').scrollLeft;
    scrollTop = document.querySelector('.map-main').scrollTop;
    e.preventDefault(); // Prevent default to avoid conflicts
});

document.addEventListener('mousemove', (e) => {
    if (!isDragging) return;

    const x = e.pageX - document.querySelector('.map-main').offsetLeft;
    const y = e.pageY - document.querySelector('.map-main').offsetTop;

    const walkX = (x - startX) * 1;
    const walkY = (y - startY) * 1;

    document.querySelector('.map-main').scrollLeft = scrollLeft - walkX;
    document.querySelector('.map-main').scrollTop = scrollTop - walkY;
    e.preventDefault(); // Prevent default to avoid conflicts
});

document.addEventListener('mouseup', () => {
    isDragging = false;
});

function mapEnlarge() {
    if (!mapWrapper.classList.contains('full')) {
        // window.scrollTo(0, 0);
        mapWrapper.classList.add('full');
        mapDetails.style.width = '100%';

        centerMap();
    }
    else {
        mapWrapper.classList.remove('full');
        mapDetails.style.width = '1000px';
        // document.querySelector('.summer-interactive').scrollIntoView()
    }
}

function mapZoomIn() {
    const currentWidth = mapDetails.clientWidth;
    if (mapWrapper.classList.contains('full')) {
        if (currentWidth < 4000) {

            mapDetails.style.width = currentWidth + 200 + 'px';
            mapMainContainer.scrollLeft = mapMainContainer.scrollLeft + scrollLeftSpace;
            mapMainContainer.scrollTop = mapMainContainer.scrollTop + scrollTopSpace;
        }
    }
    else {
        if (currentWidth < 2600) {

            mapDetails.style.width = currentWidth + 200 + 'px';
            mapMainContainer.scrollLeft = mapMainContainer.scrollLeft + scrollLeftSpace;
            mapMainContainer.scrollTop = mapMainContainer.scrollTop + scrollTopSpace;
        }
    }
}

function mapZoomOut() {
    const currentWidth = mapDetails.clientWidth;
    if (mapWrapper.classList.contains('full')) {
        if (currentWidth - 200 > 1800) {

            mapDetails.style.width = currentWidth - 200 + 'px';
            mapMainContainer.scrollLeft = mapMainContainer.scrollLeft - scrollLeftSpace;
            mapMainContainer.scrollTop = mapMainContainer.scrollTop - scrollTopSpace;
        }
    }
    else {
        if (currentWidth > 1000) {

            mapDetails.style.width = currentWidth - 200 + 'px';
            mapMainContainer.scrollLeft = mapMainContainer.scrollLeft - scrollLeftSpace;
            mapMainContainer.scrollTop = mapMainContainer.scrollTop - scrollTopSpace;
        }
    }

}

document.addEventListener("DOMContentLoaded", function () {
    centerMap();
});


// Function to check if a query parameter is present in the URL
function isQueryParamPresent(paramName) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has(paramName);
}

// Usage example
const mapCoordinatesPresent = isQueryParamPresent('mapCoordinates');

if (mapCoordinatesPresent) {
    document.querySelector('.shopify-section.image-banner').classList.add('hidden');
    document.querySelector('.summer-interactive').classList.add('hidden');
    document.querySelector('.map-grid').classList.remove('hidden');
    createGrid();

}


function createGrid() {


    for (let i = 0; i < 100; i++) {
        const gridBlock = document.createElement('div');
        gridBlock.className = 'grid-block';
        if (i < 10) {
            gridBlock.textContent = i + '0';
        }
        if (i % 10 == 0) {
            gridBlock.textContent = i;
        }
        gridWrapper.appendChild(gridBlock);
    }

    // Add the grid to the 'map-grid' container
    document.querySelector('.map-grid').prepend(gridWrapper);
}

function centerMap() {
    if (mapMainContainer) {
        var middleVertical = (mapMainContainer.scrollHeight - mapMainContainer.clientHeight) / 2;
        var middleHorizontal = (mapMainContainer.scrollWidth - mapMainContainer.clientWidth) / 2;

        mapMainContainer.scrollTop = middleVertical;
        mapMainContainer.scrollLeft = middleHorizontal;
    }
}



var mousePinEntered = false;
var mousePinClicked = false;
mapPin.forEach(pin => {
    pin.addEventListener('click', () => {
        mapPin.forEach(mp => {
            if (mp !== pin){
                mp.classList.remove('active');
            }
        });
        pin.classList.contains('active') ? '' : scrollToView(pin.style.left, pin.style.top);
        pin.classList.toggle('active');

        mapDestination.forEach(destination => {

            if (destination.dataset.name == pin.dataset.name && destination.dataset.category == pin.dataset.category) {

                mapDestination.forEach(md => {
                    if (md !== destination)
                        md.style.display = 'none';
                })

                destination.style.display == 'block' ? destination.style.display = 'none' : destination.style.display = 'block';
            }
        });


        destinationCards.forEach(destination => {
            if (destination.dataset.name == pin.dataset.name && destination.dataset.category == pin.dataset.category) {
              if(destination.classList.contains('active')){
                  destination.classList.remove('active');
              }else{
                
                destination.classList.add('active');
                destinationContainer.scrollBy(0, $(destination).position().top - 50);
              }
            }
          else{
            if(destination.classList.contains('active')){
                  destination.classList.remove('active');
            }
          }

        });
      
    });

    // pin.addEventListener('mouseover', function(){
        
    // if (!mousePinEntered) {
    //     destinationCards.forEach(dc => {
    //         if (dc !== pin){
    //             dc.classList.remove('hover');
    //         }
    //     });
    //     destinationCards.forEach(destination => {
    //         if (destination.dataset.name == pin.dataset.name && destination.dataset.category == pin.dataset.category) {
    //           destination.classList.add('hover');
    //         }
    //     });
    // }
    // });
    // pin.addEventListener('mouseout', function(){
    //     mousePinEntered = false
    //           destinationCards.forEach(dc => {
    //             dc.classList.remove('hover');
    //     });
    // });
});


destinationCards.forEach(pin => {
    pin.addEventListener('click', () => {
        mapPin.forEach(mp => {
            if (mp !== pin){
                mp.classList.remove('active');
            }
        });

        mapPin.forEach(destination => {

            if (destination.dataset.name == pin.dataset.name && destination.dataset.category == pin.dataset.category) {
              destination.classList.add('active');
            }
        });
        destinationCards.forEach(dc => {
                dc.classList.remove('active');
        });
      pin.classList.add('active');
    });
})

var mouseEntered = false;
destinationCards.forEach(des => {
    des.addEventListener('mouseover', function(){
        
    if (!mouseEntered) {
        scrollToView(des.dataset.left, des.dataset.top);

        mapPin.forEach(mp => {
                mp.classList.remove('hover');
        });

        mapPin.forEach(destination => {

            if (destination.dataset.name == des.dataset.name && destination.dataset.category == des.dataset.category) {
              destination.classList.add('hover');
            }
        });
    }

    });
    des.addEventListener('mouseout', function(){
        mapPin.forEach(mp => {
                mp.classList.remove('hover');
        });
        mouseEntered = false
    });
})

function scrollToView(left, top){
    const getLeft = mapDetails.clientWidth * parseFloat(`.${left}`);
    const getTop = mapDetails.clientHeight * parseFloat(`.${top}`);
    // mapMainContainer.style.scrollBehavior = 'smooth';
    mapMainContainer.scroll({
        left: getLeft - mapMainContainer.clientWidth/2,
        top: getTop - mapMainContainer.clientHeight/2,
        behavior:'smooth'
    })
    // mapMainContainer.scrollLeft = getLeft - mapMainContainer.clientWidth/2;
    // mapMainContainer.scrollTop = getTop - mapMainContainer.clientHeight/2;
    // mapMainContainer.style.scrollBehavior = 'unset';
}

document.querySelector('.map-footer').addEventListener('click', function(){
    document.querySelector('.map-footer-subheading').classList.toggle('hidden');
});

document.querySelectorAll('.mobile-footer button').forEach(btn =>{
    btn.addEventListener('click', function(){
        mapEnlarge();
    });
})

document.addEventListener('gesturestart', function (e) {
    e.preventDefault();
});

document.addEventListener('touchmove', function (e) {
    if (e.scale !== 1) {
        e.preventDefault();
    }
}, { passive: false });


function mobileZoomIn(multiplier) {
    const currentWidth = mapDetails.clientWidth;
    if (mapWrapper.classList.contains('full')) {
        if (currentWidth < 4600) {

            mapDetails.style.width = currentWidth + .5 * multiplier + 'px';
            mapMainContainer.scrollLeft = mapMainContainer.scrollLeft + scrollLeftSpace;
            mapMainContainer.scrollTop = mapMainContainer.scrollTop + scrollTopSpace;
        }
    }
}

function mobileZoomOut(multiplier) {
    const currentWidth = mapDetails.clientWidth;
    if (mapWrapper.classList.contains('full')) {
        if (currentWidth > 1400) {

            mapDetails.style.width = currentWidth - .5 * multiplier + 'px';
            mapMainContainer.scrollLeft = mapMainContainer.scrollLeft - scrollLeftSpace;
            mapMainContainer.scrollTop = mapMainContainer.scrollTop - scrollTopSpace;
        }
    }
}

mapMainContainer.addEventListener('gesturestart', function (e) {
    e.preventDefault();
    if (e.scale < 1.0) {
        mapZoomOut();
    } else if (e.scale > 1.0) {
        mapZoomIn();
    }
});

mapMainContainer.addEventListener('touchmove', function (e) {
    if (e.scale !== 1) {
        e.preventDefault();
    }
    
    if (e.scale < 1.0) {
        mapZoomOut();
    } else if (e.scale > 1.0) {
        mapZoomIn();
    }
}, { passive: false });